import React from 'react';
import { DataSourceBadge, LoadingDots } from './constants';

export default function SpotForecastTab({ windyForecast, omHourly, tabData, tabLoading }) {
  const wf = (tabData.forecast?.windy_forecast?.length > 0 ? tabData.forecast.windy_forecast : windyForecast) || [];
  const oh = (tabData.forecast?.om_hourly?.length > 0 ? tabData.forecast.om_hourly : omHourly) || [];

  if (tabLoading.forecast && !tabData.forecast && wf.length === 0) {
    return <LoadingDots />;
  }

  return (
    <div className="space-y-4" data-testid="spot-forecast">
      {wf.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2"><p className="text-[10px] tracking-widest uppercase text-muted-foreground">Windy 24h</p><DataSourceBadge label="Windy" active /></div>
          <div className="bg-bg-subtle/80 border border-white/10 rounded-2xl overflow-hidden"><div className="flex overflow-x-auto scrollbar-hide">
            {wf.slice(0, 12).map((h, i) => { const t = h.time ? new Date(h.time) : null; const hr = t ? t.getHours() : i; return (
              <div key={i} className="flex-shrink-0 w-16 py-3 text-center border-r border-white/5 last:border-r-0">
                <p className="text-[9px] text-muted-foreground mb-1">{t ? `${hr % 12 || 12}${hr < 12 ? 'a' : 'p'}` : `+${i}h`}</p>
                <p className="text-xs font-bold">{h.wave_height_ft || '-'}'</p><p className="text-[9px] text-muted-foreground">{h.wave_period_s || '-'}s</p>
              </div>); })}
          </div></div>
        </div>
      )}
      {oh.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2"><p className="text-[10px] tracking-widest uppercase text-muted-foreground">Open-Meteo Marine</p><DataSourceBadge label="Open-Meteo" active /></div>
          <div className="bg-bg-subtle/80 border border-white/10 rounded-2xl overflow-hidden"><div className="flex overflow-x-auto scrollbar-hide">
            {oh.slice(0, 24).map((h, i) => { const t = h.time ? new Date(h.time) : null; const hr = t ? t.getHours() : i; return (
              <div key={i} className="flex-shrink-0 w-16 py-3 text-center border-r border-white/5 last:border-r-0">
                <p className="text-[9px] text-muted-foreground mb-1">{t ? `${hr % 12 || 12}${hr < 12 ? 'a' : 'p'}` : `+${i}h`}</p>
                <p className="text-xs font-bold">{h.wave_height_ft !== undefined ? h.wave_height_ft : '-'}'</p><p className="text-[9px] text-muted-foreground">{h.wave_period_s || '-'}s</p>
              </div>); })}
          </div></div>
        </div>
      )}
    </div>
  );
}
